'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _common = require('./common');

exports.default = function (l) {
  l = (0, _common.attachDefault)(l);
  var keys = Object.keys(l);

  return function () {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var a = arguments[1];

    if ((0, _ramda.unnest)(keys.map(function (k) {
      return (0, _common.toHttpMethods)(k, l[k]);
    })).some(function (m) {
      return m[1].indexOf(a.type) > -1;
    })) return Object.assign({}, s, { isLoading: true, error: null });

    if (keys.map(_common.toSet).indexOf(a.type) === -1) return s;

    // if (a.error)
    //   return Object.assign({}, s, { error: a.error, isLoading: false });

    var path = (0, _ramda.is)(Function, a.path) ? a.path(a.params, s, a.statusCode) : a.path;

    var state = Object.assign({}, s, {
      isLoading: false,
      error: a.error
    });

    var idx = (0, _ramda.last)(path);
    if ((0, _ramda.is)(Number, idx)) {
      var arr = (0, _ramda.init)(path);

      if ((0, _ramda.isNil)(a.payload)) // delete
        return (0, _ramda.over)((0, _ramda.lensPath)(arr), (0, _ramda.remove)(idx, 1), state);

      if (a.method === 'patch') {
        return (0, _ramda.reduce)(function (p, c) {
          return (0, _ramda.set)((0, _ramda.lensPath)((0, _ramda.append)(c, path)), a.payload[c], p);
        }, state, Object.keys(a.payload));
      }

      if (idx === 0 && (0, _ramda.isNil)((0, _ramda.view)((0, _ramda.lensPath)(arr), state))) state = (0, _ramda.set)((0, _ramda.lensPath)(arr), [], state);
    } else if (idx instanceof Error) {
      state.error = {
        source: a.type,
        text: idx.message
      };
      return state;
    }

    return (0, _ramda.set)((0, _ramda.lensPath)(path), a.payload, state);
  };
};


//////////////////
// WEBPACK FOOTER
// ../dist/reducer.js
// module id = 600
// module chunks = 0